import React from 'react'
import Grid from 'material-ui/Grid'
import Tabs, {Tab} from 'material-ui/Tabs'
import {withStyles} from 'material-ui/styles'
import styles from './styles'
import {connect} from 'react-redux';
import {compose} from 'recompose';

import Title from '../ui/title'
import Content from '../ui/content'
import FileUploadSettings from "./fileuploadsettings";
import AccountLockoutSettings from "./accountlockoutsettings";

class Security extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: "file_upload_settings"
    }
    this.handleTabChange = this.handleTabChange.bind(this)
  }

  handleTabChange(e, selectedTab) {
    this.setState({selectedTab});
  }

  render() {
    const {
      translate,
      fileUploadSettings,
      updateFileUploadSettings,
      accountLockoutSettings,
      updateAccountLockoutSettings,
      getAppSetting,
      impersonating,
      softwareUpdate
    } = this.props

    const {
      selectedTab,
    } = this.state

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    return (
      <div style={{marginTop: margintop}}>
        <Title title={translate("security")}/>
        <Content translate={translate}>
          <Grid container direction="row" justify="center">
            <Grid item xs={12} md={6}>
              <Tabs
                value={selectedTab}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                centered
                fullWidth
              >
                <Tab value="file_upload_settings"
                     label={translate("security_file_upload_settings_tab")}/>
                <Tab value="account_lockout_settings"
                     label={translate("security_account_lockout_settings_tab")}/>

              </Tabs>
              {(selectedTab === "file_upload_settings") &&
                <FileUploadSettings translate={translate}
                                  fileUploadSettings={fileUploadSettings}
                                  update={updateFileUploadSettings}
                                  getAppSetting={getAppSetting}
                ></FileUploadSettings>}

              {(selectedTab === "account_lockout_settings") &&
                <AccountLockoutSettings translate={translate}
                                accountLockoutSettings={accountLockoutSettings}
                                update={updateAccountLockoutSettings}></AccountLockoutSettings>}
            </Grid>
          </Grid>
        </Content>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Security);


